import type { Finding } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

export const getByDCSNamespace = async ({
  dataCollectionStatementId,
  namespace,
  resolved,
  signal,
}: {
  dataCollectionStatementId: string
  namespace: string
  resolved: boolean
  signal?: AbortSignal
}): Promise<Finding[]> => {
  const response = await apiClient.get(
    `${endpoints.findings}/dataCollectionStatements/${dataCollectionStatementId}/namespaces/${namespace}?resolved=${resolved}`,
    { signal },
  )
  return unwrapCollection<Finding>(response)
}
